
import thunkMiddleware from 'redux-thunk';
import {createLogger} from "redux-logger";
import {History} from "history";
import {applyMiddleware, compose, createStore} from "redux";
import createRootReducer from "./reducers/reducers";
import {routerMiddleware} from "connected-react-router";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import {ACTIONS} from "./actions";
import {HIGH_LEVEL_CONFIG} from "../config/high_level_config";
import i18n from "../i18n";
import Moment from "react-moment";
import {insertScripts} from "../utils/insert_scripts";

// defaults to localStorage for web

const persistConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2,
    blacklist: ['router'],
    version: 1
};

export function configStore(history: History) {

    const loggerMiddleware = createLogger();

    const reducer = createRootReducer(history);

    const persistedReducer = persistReducer(persistConfig, reducer);

    let store = createStore(
        persistedReducer, // root reducer with router state
        compose(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                thunkMiddleware, // lets us dispatch() functions
                loggerMiddleware // neat middleware that logs actions
            ),
        )
    );

    let persistor = persistStore(store, {}, () => {
        const state: any = store.getState();

        let language = HIGH_LEVEL_CONFIG.DEFAULT_LANGUAGE;

        if (window.location.hostname === HIGH_LEVEL_CONFIG.ITALIAN_DOMAIN) {
            language = "it";
        } else if (window.location.hostname === HIGH_LEVEL_CONFIG.ENGLISH_DOMAIN) {
            language = "en";
        }

        // we have to throw a change language to update the language of the displayed items
        i18n.changeLanguage(language).then(() => {
            Moment.globalLocale = language;
            store.dispatch(ACTIONS.changeLanguageState(language));
        });

        if (state.app && state.app.mapping) {

            let currentTime = new Date().getTime();
            if (state.app.mapping_age && currentTime - state.app.mapping_age <= HIGH_LEVEL_CONFIG.MAX_MAPPING_AGE_SECONDS*1000) {
                store.dispatch(ACTIONS.pagesMappingLoaded(state.app.mapping));

            } else {
                // @ts-ignore
                store.dispatch(ACTIONS.pagesMappingLoading(language));
            }

        } else {
            // @ts-ignore
            store.dispatch(ACTIONS.pagesMappingLoading(language));
        }

        try {
            setTimeout(() => insertScripts(), HIGH_LEVEL_CONFIG.SCRIPTS_DELAY_SECONDS*1000);
        } catch(e) {
        }
    });

    return [store, persistor];
}
